
import { useNotificationsManager } from '@/hooks/use-notifications-manager';

export const useMedicationNotifications = () => {
  // Use the consolidated notifications manager that includes medication notifications
  useNotificationsManager();
};
